import React, { FC, ReactNode } from 'react'
import { TIconComponent } from 'transfix-icons/types'
import { Box, Divider, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

const useTeamMemberInfoRowStyles = makeStyles({
  title: {
    color: brandColors.coolGray6,
  },
  divider: {
    borderColor: brandColors.coolGray1,
  },
})

interface ITeamMemberInfoRowProps {
  /**
   * Icon of the row
   */
  icon: TIconComponent
  /**
   * Title of the row
   */
  title: string
  /**
   * Content of the row
   */
  children: ReactNode | ReactNode[]
}

export const TeamMemberInfoRow: FC<ITeamMemberInfoRowProps> = ({ children, icon: Icon, title }) => {
  const classes = useTeamMemberInfoRowStyles()
  return (
    <Box>
      <Box display='flex' alignItems='flex-start' py={2}>
        <Box mr={2}>
          <Icon size='xlarge' color='coolGray5' />
        </Box>
        <Box>
          <Typography className={classes.title} variant='overline'>
            {title}
          </Typography>
          {children}
        </Box>
      </Box>

      <Divider className={classes.divider} />
    </Box>
  )
}
